import React from 'react';
import { graphql, withApollo } from "react-apollo";

import { channels } from '../../graphql/queries';
import { addChannel } from '../../graphql/mutations';

import { ColHead, ColError, ColLoading } from '../chunk'
import Tile from "../Tile"

class ChannelList extends React.Component {

	constructor(props) {
		super(props);
    	this.handleNew = this.handleNew.bind(this);
	}

	handleNew(e) {
		const name = window.prompt('Please insert a name for the new channel:');
		if(!name || name.trim() === '') return;
		
		this.props.client.mutate({
			mutation: addChannel,
			variables: { name: name },
			refetchQueries: [{query: channels}]
		})
		.then(res => {
			this.props.history.replace('/channels/' + res.data.addChannel.id);
		})
		.catch(e => {
			alert('addChannel Error: ' + e);
		});
	}


	render() {

		let { loading, error, channels } = this.props.data;
		if( loading ) return (<div className="col col-2"><ColLoading /></div>)
	    if( error ) return (<div className="col col-2"><ColError /></div>)

		return (
			<div className="col col-2">
            	<ColHead icon="comments" title="CHANNELS LIST" meta={`${channels.length} Channels`} />

		        <div className="grid-list">
			        {channels.map(({ id, name }) => (
			        	<Tile key={id} id={id} text={name} url={`/channels/${id}`} />
		      		))}
		      		{/*<Tile onClick={this.handleNew} text="+ create channel" />*/}
		      		<div onClick={this.handleNew} className="tile">+ create channel</div>
		        </div>
		    </div>
      	)
	}
}


export default withApollo(graphql(channels)(ChannelList))


// WEBPACK FOOTER //
// ./src/components/channel/ChannelList.js